import React, { useState } from 'react'
import { Button, Dropdown, NavDropdown } from 'react-bootstrap'
import { formatCurrencyHasSymbol } from '../../../../../utils/commonFunctions'
import { formatDateBilling } from '../../billingOverview/component/CreditGrants/CreditGrants'
import CCModal2025 from '../../../../../components/ccModal2025'
import { onBoardingChangeAddOnsApi } from '../../../../../constants/ApiConfigs'
import { callApiWithoutDispatch } from '../../../../../utils/apiUtils'
import { IoIosInformationCircleOutline } from 'react-icons/io'
import { I18n } from 'react-redux-i18n'
import { FaArrowRight } from 'react-icons/fa6'
import { BILLING_PLAN_TYPE } from '../../../../../features/signup/constantStep'
import { groupBillingItems, handleResultBillingPayment } from '../../../utils/billingCommonFunc'
import PaymentMethodSelector from './PaymentMethodSelector'

const UpdateAddOns = ({
	context = {},
	auth = {},
	handleLoadBillingUsage,
	onResetPreviewBillingPlan,
	dataPreview = {},
	billingUsage = {},
	onResetPreviewAddOns,
	...props
}) => {
	const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(dataPreview?.paymentMethods?.[0])

	const handleConfirmPayment = async () => {
		props.loadingActions.showLoadingSpiner()
		if (!selectedPaymentMethod?.paymentId) {
			context.notification('error', 'Please select a payment method')
			return
		}
		try {
			props.loadingActions.showLoadingSpiner()
			const response = await callApiWithoutDispatch(onBoardingChangeAddOnsApi, {
				method: 'POST',
				body: JSON.stringify({
					fleetId: auth?.selectedFleet?.fleetId,
					addOnIds: dataPreview?.addOnIds,
					removedAddOnIds: dataPreview?.removedAddOnIds,
					paymentId: selectedPaymentMethod?.paymentId,
					returnUrl: window.location.href,
				}),
			})
			const res = response?.res?.response || {}
			const { isSuccess, is3ds } = handleResultBillingPayment(res)
			if (isSuccess) {
				context.notification('success', 'Payment confirmed successfully')
				handleLoadBillingUsage()
				onResetPreviewBillingPlan()
				onResetPreviewAddOns()
			} else if (is3ds) {
				return;
			} else {
				context.notification('error', 'Failed to confirm payment')
			}
		} catch (error) {
			context.notification('error', 'Failed to confirm payment')
		} finally {
			props.loadingActions.hideLoadingSpiner()
		}
	}

	const handleSelectPaymentMethod = (paymentMethod) => {
		setSelectedPaymentMethod(paymentMethod)
	}

	return (
		<div className="update-subscription preview-update">
			<div className="update-subscription-header">
				<p>{I18n.t('billingUsage.updateSubscription')}</p>
				<span>{I18n.t('billingUsage.reviewAndUpdate')}</span>
			</div>
			<div className="cr-plan">
				<p>
					{I18n.t('billingUsage.addOns')}
				</p>
			</div>
			<div className="itemUpdate">
				{
					groupBillingItems(dataPreview?.items)?.map(item => {
						return (
							<div>
								{item.amount !== 0 && <p key={item._id}>
									<span className="add-on-name">{item.name}</span>
									<span className={`add-on-price ${item.amount <= 0 ? 'negative' : ''}`}>
										{
											`${formatCurrencyHasSymbol(item.amount || 0, billingUsage.currencyISO)}${!(item?.name?.includes('Setup fee') || item?.name?.includes('Setup Fees')) ? ('/' + (billingUsage.billingType === BILLING_PLAN_TYPE.annual ? 'Annual' : 'Monthly')) : ''}`
										}
									</span>
								</p>}
								{
									item.items.map(item => {
										if (item.amount === 0) {
											return null
										}
										return (
											<p key={item._id} style={{ marginLeft: '10px' }}>
												<span className="add-on-name">{item.name}</span>
												<span className={`add-on-price ${item.amount <= 0 ? 'negative' : ''}`}>
													{
														`${formatCurrencyHasSymbol(item.amount || 0, billingUsage.currencyISO)}${!(item?.name?.includes('Setup fee') || item?.name?.includes('Setup Fees')) ? ('/' + (billingUsage.billingType === BILLING_PLAN_TYPE.annual ? 'Annual' : 'Monthly')) : ''}`
													}
												</span>
											</p>
										)
									})
								}
							</div>
						)
					})
				}
			</div>
			<p className="total-due-today">
				<span>{I18n.t('billingUsage.totalDueToday')}</span>
				<span>{formatCurrencyHasSymbol(dataPreview?.amountDue || 0, billingUsage.currencyISO)}</span>
			</p>
			<div className="d-flex align-items-start" style={{ border: '1px solid #3F4350', padding: '10px', borderRadius: '5px', marginTop: '16px' }}>
				<IoIosInformationCircleOutline fontSize={24} style={{ color: '#60A5FA' }} />
				<p style={{ fontSize: '14px', fontWeight: '500', marginLeft: '10px' }}>
					<span style={{ color: '#60A5FA' }}>{I18n.t('billingUsage.howProrationWorks')}</span> <br />
					<span>
						{I18n.t('billingUsage.prorationDescription')}
					</span>
				</p>
			</div>
			{
				dataPreview?.paymentMethods?.length > 0 && (
					<>
						<PaymentMethodSelector
							selectedPaymentMethod={selectedPaymentMethod}
							paymentMethods={dataPreview?.paymentMethods}
							onSelectPaymentMethod={handleSelectPaymentMethod}
						/>
						<div className="text-center">
							<Button className="btn-save" onClick={handleConfirmPayment}>{I18n.t('billingUsage.confirmPayment')}</Button>
						</div>
					</>
				)
			}
		</div>
	)
}

export default UpdateAddOns

